import graphql__6383b7adf9c35ee7ec92 from "./__generated__/ContributionDetailsModal_contribution.graphql.js";import { connect } from "react-redux";
import { useFragment } from "react-relay";
import { graphql } from "react-relay";

import withResourcesList from "../../ResourcesList/withResourcesList";
import Modal from "../../Modals/Modal";
import ListContribution from "./ListContribution";
import { unselectItem } from "../../../reducers/resourcesList/selection";

// This view is used in the ContributionsListWithNavigation mobile and tablet interface,
// which only displays the navigation on the first level, and then shows the
// contribution's content inside this modal.
//
const ContributionDetailsModal = props => {
  const contribution = useFragment(
    ContributionDetailsModal_contribution,
    props.contribution
  );
  const { unselectItem } = props;

  return (
    <Modal title={contribution.title} onRequestClose={unselectItem}>
      <ListContribution contribution={contribution} />
    </Modal>
  );
};

function mapDispatchToProps(dispatch, ownProps) {
  const { resourcesListKey } = ownProps;

  return {
    unselectItem: () => dispatch(unselectItem(resourcesListKey))
  };
}

const ContributionDetailsModalWithRedux = connect(
  null,
  mapDispatchToProps
)(ContributionDetailsModal);

const ContributionDetailsModal_contribution = graphql__6383b7adf9c35ee7ec92;

export default withResourcesList(ContributionDetailsModalWithRedux);
